export { viewClosingLabel } from './viewEditorialLabels.js';

export function cleanViewClosing(value) {
  if (!value || typeof value !== 'object') return null;
  const text = typeof value.text === 'string' ? value.text.replace(/<[^>]*>/g, '').trim().slice(0, 1800) : '';
  return text ? { text } : null;
}
